export const MEILISEARCH_ERRORS_CODES_TO_IGNORE = ['index_not_found'];
